import { useState } from "react";

export const useCart = (initialItems = []) => {
    const [items, setItems] = useState(initialItems);
    const [isCartOpen, setIsCartOpen] = useState(false);
    const addItem = (newItem) => {
        setItems(prevItems => {
            const existingItem = prevItems.find(item => item?.id === newItem?.id && item?.size === newItem?.size);
            if (existingItem) {
                return prevItems?.map(item =>
                    item?.id === newItem?.id && item?.size === newItem?.size
                        ? { ...item, quantity: item?.quantity + newItem?.quantity }
                        : item
                );
            }
            return [...prevItems, newItem];
        });
    };
    const removeItem = (itemId) => {
        setItems(prevItems => prevItems?.filter(item => item?.id !== itemId));
    };
    const updateQuantity = (itemId, newQuantity) => {
        if (newQuantity < 1) {
            removeItem(itemId);
            return;
        }
        setItems(prevItems =>
            prevItems?.map(item =>
                item?.id === itemId ? { ...item, quantity: newQuantity } : item
            )
        );
    };
    const clearCart = () => {
        setItems([]);
    };
    const openCart = () => setIsCartOpen(true);
    const closeCart = () => setIsCartOpen(false);
    return {
        items,
        isCartOpen,
        addItem,
        removeItem,
        updateQuantity,
        clearCart,
        openCart,
        closeCart,
        totalItems: items.reduce((total, item) => total + item?.quantity, 0),
        subtotal: items.reduce((total, item) => total + (item?.price * item?.quantity), 0)
    };
};
export const sampleCartItems = [
    {
        id: 1,
        name: "Gildan® Softstyle® Unisex Soccer",
        image: "/image/tshirts.png",
        quantity: 18,
        size: "M",
        price: 22.94
    },
    {
        id: 2,
        name: "Nike Pro Dri-FIT T-Shirt",
        image: "/image/tshirts.png",
        quantity: 2,
        size: "L",
        price: 34.99
    }
];